import { CF7_FORM_ID, CF7_UNIT_TAG, WP_API_URL } from "../constants/wordpress";

export class ContactApiError extends Error {
  constructor(message, status) {
    super(message);
    this.name = "ContactApiError";
    this.status = status;
  }
}

/**
 * Submit via Contact Form 7 REST API.
 * Headless React must send CF7 hidden fields (_wpcf7, _wpcf7_unit_tag) manually.
 */
export async function submitContactToCf7(
  formId,
  { name, email, phoneNumber, message },
) {
  const url = `${WP_API_URL}/contact-form-7/v1/contact-forms/${formId}/feedback`;

  const formData = new FormData();
  formData.append("_wpcf7", String(formId));
  formData.append("_wpcf7_unit_tag", CF7_UNIT_TAG);
  formData.append("your-name", name);
  formData.append("your-email", email);
  formData.append("your-phone", phoneNumber?.trim() || "");
  formData.append("your-message", message);

  const response = await fetch(url, {
    method: "POST",
    body: formData,
  });

  let body = {};
  try {
    body = await response.json();
  } catch {
    // ignore non-JSON responses
  }

  if (!response.ok) {
    throw new ContactApiError(
      body.message || `Contact form error (${response.status})`,
      response.status,
    );
  }

  if (body.status === "mail_sent") {
    return body;
  }

  const fieldErrors = (body.invalid_fields || [])
    .map((field) => field.message)
    .filter(Boolean)
    .join(" ");

  throw new ContactApiError(
    fieldErrors || body.message || "Failed to send message.",
    400,
  );
}

/** Submit using the configured CF7 form ID */
export function submitContactForm(values) {
  return submitContactToCf7(CF7_FORM_ID, values);
}
